import { CustomizationType } from '../types/orders';

export const OrderMarketplaces = ['alza', 'allegro', 'kaufland', 'mall', 'other'];
export const OrderStatuses = [
    'inProcess',
    'lost',
    'received',
    'processing',
    'processed',
    'onTheWay',
    'atPickupPoint',
    'delivered',
    'returnedBack',
    'canceled',
    'returningBack',
    'onResend',
    'refundInProcess',
    'receivedBack',
    'partlyReceivedBack',
    'preReceived',
    'preOrder',
    'incorrect',
    'suspended',
    'waitingForPayment',
    'waitingForShipment',
    'productsNotAvailable',
    'packed',
    'waitingForCarrier',
];

export const OrderSubStatuses = ['partRefund', 'refund', 'productComplaint', 'productExchange'];
export const OrderShippingMethods = ['DEL', 'PER'];
export const OrderCustomsProductTypes = ['gift', 'documents', 'saleOfGoods', 'commercialSample', 'returnedGoods'];
export const OrderValidCustomizationTypes = Object.keys(CustomizationType) as Array<keyof typeof CustomizationType>;

export const OrderStatusesTo: Record<string, string[]> = {
    preReceived: ['incorrect', 'suspended', 'productsNotAvailable', 'waitingForPayment', 'forShipment', 'preOrder'],
    productsNotAvailable: ['incorrect', 'suspended', 'canceled', 'preOrder'],
    waitingForPayment: ['incorrect', 'suspended', 'canceled', 'waitingForShipment', 'preOrder'],
    preOrder: ['preReceived', 'canceled'],
    incorrect: ['productsNotAvailable', 'waitingForPayment', 'suspended', 'canceled'],
    suspended: ['incorrect', 'canceled', 'preReceived'],
    waitingForShipment: ['incorrect', 'suspended', 'canceled', 'preOrder'],
    received: [
        'incorrect',
        'productsNotAvailable',
        'waitingForPayment',
        // "suspended",
        'forShipment',
        'inProcess',
        'canceled',
    ],
    inProcess: ['incorrect', 'packed', 'canceled', 'suspended'],
    packed: ['incorrect', 'waitingForCarrier', 'suspended'],
    waitingForCarrier: ['incorrect', 'onTheWay'],
    onTheWay: ['lost', 'returningBack', 'returnedBack', 'atPickupPoint'],
    atPickupPoint: ['delivered', 'lost', 'returningBack', 'returnedBack'],
    // delivered: [],
    returnedBack: ['incorrect'],
    lost: ['incorrect'],
    processing: ['incorrect'],
    processed: ['incorrect'],
    canceled: ['incorrect'],
    onResend: ['incorrect'],
    refundInProcess: ['incorrect'],
    receivedBack: ['incorrect'],
    partlyReceivedBack: ['incorrect'],
    returningBack: ['incorrect', 'returnedBack'],
    shoptetImport: ['incorrect'],
    forShipment: ['incorrect'],
};

export const OrderPaidAbleStatusesFrom = [
    'preReceived',
    'preOrder',
    'productsNotAvailable',
    'waitingForPayment',
    'canceled',
    'incorrect',
    'suspended',
    'waitingForShipment',
];

export const OrderPaidAbleStatusesTo = ['preReceived', 'waitingForShipment', 'waitingForPayment'];

export const OrderPaidEditKeys = [
    'STATUS',
    'PAYMENT_METHOD',
    'PAID',
    'ALLOW_EXPEDITION',
    'WAITING_FOR_SHIPMENT_AT',
    'PRERECEIVED_AT',
    'COD_CURRENCY',
    'COD_PRICE',
    'COD_REF_NUMBER',
];

export const PAYMENT_METHOD_CASH_ON_DELIVERY = '0';
export const PAYMENT_METHOD_CARD_ONLINE = '1';
export const PAYMENT_METHOD_BANK_TRANSFER = '2';

export const SOURCE_SYS_MYSKLADON = 'myskladon';
export const SOURCE_SYS_WMS_SKLADON = 'wmsSkladon';
export const SOURCE_SYS_PIPES = 'pipes';
export const SOURCE_SYS_API = 'api';
